import { isDevMode } from '@angular/core'
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core'

/**
 * Last-resort handler for missing translation keys (RNF-08, AC-14).
 *
 * The active-locale → pt-BR fallback is already provided by ngx-translate's
 * `useDefaultLang: true` + `defaultLanguage: 'pt-BR'`. This handler only fires
 * when a key is missing in BOTH the active locale and pt-BR: it returns the raw
 * key (instead of an empty string) and logs in dev so the gap is visible.
 */
export class TrendMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (isDevMode()) {
      console.warn(`[i18n] missing translation key: ${params.key}`)
    }
    return params.key
  }
}
